import { getInitials } from "@/utils/get-initals";
import { Box, Avatar, Typography, styled } from "@mui/material";
import Banner from "assets/images/abstract-wireframe.jpg";

const BannerImage = styled("img")(() => ({
  width: "100%",
  height: 160,
  objectFit: "cover",
  display: "block",
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  padding: theme.spacing(0, 3, 2, 3),
}));

const ProfileRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(2),
  marginTop: -32,
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  fontSize: "1.5rem",
  fontWeight: 600,
  border: `3px solid ${theme.palette.background.paper}`,
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  flexShrink: 0,
}));

const UserInfo = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  marginTop: 24,
}));

// mocked data for now
const mockedUser = {
  firstName: "WAYA",
  lastName: "ADMIN",
  role: "Super Admin",
  profileImage: null,
};

const BannerAndAvatar = ({
  firstName = mockedUser.firstName,
  lastName = mockedUser.lastName,
  role = mockedUser.role,
  profileImage = mockedUser.profileImage,
}) => {
  const initials = getInitials(firstName, lastName);

  return (
    <Box>
      <BannerImage
        src={Banner}
        alt="profile banner"
        onError={(e) => {
          e.target.style.backgroundColor = "#FF6700";
          e.target.style.display = "none";
        }}
      />

      {!Banner && (
        <Box
          sx={{
            width: "100%",
            height: 160,
            backgroundColor: "primary.main",
            opacity: 0.15,
            mt: "-160px",
            position: "relative",
          }}
        />
      )}

      <ContentWrapper>
        <ProfileRow>
          <StyledAvatar src={profileImage ?? undefined}>
            {!profileImage && initials}
          </StyledAvatar>

          <UserInfo>
            <Typography variant="h6" fontWeight={600}>
              {firstName} {lastName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {role}
            </Typography>
          </UserInfo>
        </ProfileRow>
      </ContentWrapper>
    </Box>
  );
};

export default BannerAndAvatar;
